export default {
    addressItem: null,
    sendAddress: null
}


// WEBPACK FOOTER //
// ./src/store/address-manage/state.js